<template>
    <layout-default :is-loaded="true">

        <v-layout align-center justify-center fill-height>
            <v-flex class="" style="width: 640px; max-width: 100%; flex: 0 1 auto;">
                <!--<v-card tile class="elevation-12">-->
                <div class="">
                    <h2 class="text-center mb-8 primary--text" style="font-size: 28px; line-height: 1.35;">
                        <span class="font-weight-bold">Регистрация</span>
                    </h2>
                    <!--                    <v-img width="300" class="mx-auto mb-7" src="@/assets/logo.svg"></v-img>-->
                    <!--<v-toolbar
                            color="teal"
                            dark
                            flat
                    >
                        <v-toolbar-title class="text-left " style="width:100%;">Registration</v-toolbar-title>
                        <v-spacer />
                    </v-toolbar>-->
                    <v-form @submit.prevent="signup" class="marginForm" ref="registrationForm" :lazy-validation="true">
                        <v-card-text class="px-0 pb-0 " style="position: relative;">

                            <!-- <v-text-field
                                     label="First name"
                                     name="first_name"
                                     :rules="[rules.required]"
                                     prepend-icon="mdi-account"
                                     type="text"
                                     v-model="firstName"
                             />

                             <v-text-field
                                     label="Last name"
                                     name="last_name"
                                     :rules="[rules.required]"
                                     prepend-icon="mdi-account"
                                     type="text"
                                     v-model="lastName"
                             />-->

                            <v-row dense>
                                <v-col sm="6">
                                    <v-text-field
                                            outlined
                                            flat

                                            label="Фамилия *"
                                            name="last_name"
                                            :rules="[rules.required]"
                                            type="text"
                                            v-model="user.last_name"
                                    />
                                </v-col>
                                <v-col sm="6">
                                    <v-text-field
                                            outlined
                                            flat

                                            label="Имя *"
                                            name="first_name"
                                            :rules="[rules.required]"
                                            type="text"
                                            v-model="user.first_name"
                                    />
                                </v-col>
                                <v-col sm="6">
                                    <v-text-field
                                            outlined
                                            flat

                                            label="Отчество *"
                                            name="patronymic"
                                            :rules="[rules.required]"
                                            type="text"
                                            v-model="user.patronymic"
                                    />
                                </v-col>
                                <v-col sm="6">
                                    <v-menu
                                            ref="menuDate"
                                            v-model="menuDate"
                                            :close-on-content-click="false"
                                            transition="scale-transition"
                                            min-width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                    flat
                                                    outlined

                                                    :rules="[rules.required]"
                                                    v-model="user.birthday"
                                                    label="Дата рождения *"
                                                    readonly
                                                    v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker

                                                ref="pickerDate"
                                                v-model="user.birthday"
                                                :max="new Date().toISOString().substr(0, 10)"
                                                min="1920-01-01"
                                                @change="saveDate"
                                        ></v-date-picker>

                                    </v-menu>
                                </v-col>
                                <v-col sm="6">
                                    <v-text-field
                                            validate-on-blur
                                            outlined
                                            flat

                                            v-cleave="{phone: true}"
                                            label="Телефон *"
                                            name="phone"
                                            :rules="[rules.required]"
                                            type="text"
                                            v-model="user.phone"
                                    />
                                </v-col>
                                <v-col sm="6">
                                    <v-text-field
                                            outlined
                                            flat

                                            label="Email *"
                                            name="login"
                                            :rules="[rules.required, rules.email]"
                                            type="text"
                                            v-model="user.email"
                                    />
                                </v-col>
                                <v-col sm="6">
                                    <v-select
                                            outlined
                                            label="Страна *"
                                            flat
                                            :items="getCountryList"
                                            v-model="country_id"
                                            :item-text="(item) => item.name"
                                            :item-value="(item) => item.id"
                                    >

                                    </v-select>
                                    <!--<v-text-field
                                            outlined
                                            flat
                                            solo
                                            label="Страна *"
                                            name="country_id"
                                            :rules="[rules.required]"
                                            type="text"
                                            v-model="user.country_id"
                                    />-->
                                </v-col>
                                <v-col sm="6" cols="12">
                                    <v-text-field
                                            outlined
                                            flat

                                            label="Город *"
                                            name="city"
                                            :rules="[rules.required]"
                                            type="text"
                                            v-model="user.city"
                                    />
                                </v-col>
                                <v-col sm="6" cols="12">
                                    <v-select
                                            outlined
                                            label="Пол *"
                                            flat

                                            :items="[
                                              {value: 'male', text: 'Мужской'},
                                              {value: 'female', text: 'Женский'}
                                          ]"
                                            v-model="user.gender"
                                    >

                                    </v-select>
                                </v-col>
                                <v-col sm="6" cols="12">
                                    <v-autocomplete
                                            outlined
                                            flat
                                            :rules="[rules.required]"
                                            v-model="user.role"
                                            :items="roles"
                                            label="Роль *"
                                    ></v-autocomplete>
                                </v-col>

                               <!-- <v-col sm="6" cols="12">
                                    <v-autocomplete
                                            outlined
                                            flat
                                            solo
                                            :rules="[v => !!v || 'Timezone is required']"
                                            v-model="user.timezone"
                                            :items="timezones"
                                            :item-text="(item) => item.name"
                                            :item-value="(item) => item.value"
                                            label="Timezone *"
                                    ></v-autocomplete>
                                </v-col>-->


                            </v-row>


                            <!--<v-autocomplete
                                    outlined
                                    flat
                                    solo
                                    :rules="[v => !!v || 'Timezone is required']"
                                    v-model="timezone"
                                    :items="timezones"
                                    :item-text="(item) => item.name"
                                    :item-value="(item) => item.value"
                                    label="Timezone *"
                            ></v-autocomplete>
  -->

                            <v-text-field
                                    flat
                                    outlined
                                    class="withIcon"
                                    validate-on-blur

                                    v-model="user.password"
                                    :rules="[rules.required, rules.min]"
                                    :type="showPass ? 'text' : 'password'"
                                    id="password"
                                    label="Пароль *"
                                    name="password"
                                    :counter="false"
                                    persistent-hint
                                    hint="минимум 6 символов"
                            >
                                <template v-slot:append>
                                    <v-icon size="16" @click="showPass = !showPass">
                                        {{ showPass ? 'mdi-eye' : 'mdi-eye-off' }}
                                    </v-icon>
                                </template>
                            </v-text-field>

                            <v-text-field
                                    class="withIcon"
                                    flat

                                    validate-on-blur
                                    outlined
                                    v-model="passwordConfirm"
                                    :rules="[rules.required, rules.min, rules.passwordMatch]"
                                    :type="showPass2 ? 'text' : 'password'"
                                    id="password2"
                                    label="Пароль повторно *"
                                    name="password2"
                                    :counter="false"
                                    persistent-hint
                                    hint-old="подтвердите пароль"
                            >
                                <template v-slot:append>
                                    <v-icon size="16" @click="showPass2 = !showPass2">
                                        {{ showPass2 ? 'mdi-eye' : 'mdi-eye-off' }}
                                    </v-icon>
                                </template>
                            </v-text-field>

                            <v-checkbox class=" mb-0 mt-0" :rules="[rules.required]">
                                <template v-slot:label>
                                    <div class=" body-2">

                                        Я прочитал и принимаю
                                        <router-link class="mx-1 secondary--text" to="/">Пользовательское соглашение
                                        </router-link>
                                        и
                                        <router-link class="mx-1 secondary--text" to="/">Политику конфиденциальности
                                        </router-link>
                                        .
                                    </div>
                                </template>
                            </v-checkbox>

                        </v-card-text>


                        <v-alert
                                v-if="errorMessage"
                                dense
                                outlined
                                dismissible
                                type="error"
                                class="mx-0 pa-4"
                        >
                            {{ errorMessage }}
                        </v-alert>
                        <v-card-actions class="px-0">
                            <v-spacer/>
                            <v-btn type="submit" style="width: 100%;" large class="white--text" color="primary">
                                Зарегистрироваться
                            </v-btn>
                        </v-card-actions>

                        <div class="px-0 mt-4 pb-2 grey--text body-2 text-center">
                            Уже есть аккаунт?
                            <router-link class="secondary--text ml-1" to="/login">Войти</router-link>
                        </div>

                    </v-form>
                </div>
            </v-flex>
        </v-layout>
    </layout-default>
</template>

<style scoped>
    label {
        cursor: pointer;
    }
</style>

<script>
    // import {AUTH_REQUEST, AUTH_SUCCESS} from 'actions/auth'
    // import {USER_REQUEST} from 'actions/user'
    // import { ValidationProvider, ValidationObserver } from 'vee-validate'
    // import Cookies from 'js-cookie'
    import axios from 'axios'
    import Cleave from 'cleave.js'
    import { mapActions, mapGetters } from 'vuex'
    import LayoutDefault from '@/layouts/LayoutBase.vue'
    import jstz from 'jstz'

    export default {
        /*components: {
          ValidationProvider,
          ValidationObserver
        },*/
        components: {
            LayoutDefault
        },
        name: 'registration',
        directives: {
            cleave: {
                inserted: (el, binding) => {
                    el = el.querySelector('input')
                    el.cleave = new Cleave(el, binding.value || {})
                },
                update: (el) => {
                    el = el.querySelector('input')
                    const event = new Event('input', {bubbles: true})
                    setTimeout(function () {
                        el.value = el.cleave.properties.result
                        el.dispatchEvent(event)
                    }, 100)
                },
            }
        },
        data: function () {
            return {
                showPass: false,
                showPass2: false,
                menuDate: false,
                isSubmitButtonLoading: false,
                nickname: '',
                roles: [
                    {value: 'user', text: 'Участник'},
                    {value: 'painter', text: 'Художник'},
                    {value: 'profi', text: 'Художник-Профи'},
                    {value: 'collector', text: 'Коллекционер'},
                ],
                country_id: null,
                firstName: '',
                birthday: '',
                timezone: '',
                lastName: '',
                email: '',
                user: {},
                password: '',
                passwordConfirm: '',
                errorMessage: '',
                rememberMe: true,
                rules: {
                    required: v => !!v || 'обязательное',
                    min: v => v.length >= 6 || 'минимум 6 символов',
                    email: v => /.+@.+\..+/.test(v) || 'E-mail введен неверно',
                    passwordMatch: () => this.user.password === this.passwordConfirm || ('пароли не совпадают'),
                }
            }
        },
        computed: {
            ...mapGetters({
                getUserData: 'auth/getUserData',
                getCountryList: 'user/getCountryList',
                getErrorMessage: 'auth/getErrorMessage'
            }),
            timezones: function () {
                let keys = Object.keys(jstz.olson.timezones)
                let tzs = []
                for (let i = 0; i < keys.length; i++) {
                    let ch = keys[i].split(',')[0] / 60
                    ch = ch > 0 ? '+' + ch : ch
                    tzs.push({
                        value: jstz.olson.timezones[keys[i]],
                        name: jstz.olson.timezones[keys[i]] + ` (GMT ${ch})`,
                    })
                }
                return tzs
            }
        },
        methods: {
            ...mapActions({
                postRegistrationFormData: 'auth/postRegistrationFormData',
                fetchCountryList: 'user/fetchCountryList',
            }),
            saveDate (date) {
                this.$refs.menuDate.save(date)
            },
            signup: async function () {

                const isValid = this.$refs.registrationForm.validate()
                if (!isValid) {
                    return false
                }
                this.isSubmitButtonLoading = true
                try {
                    this.errorMessage = ''
                    // const registrationFieldNameInPayload = this.email.match(/[^@]+@[^\.]+\..+/g) ? 'email' : 'nickname'
                    // const registrationFieldNameInPayload = 'nickname'
                    /* const payload = {
                       email: this.email,
                       nick: this.nickname,
                       birthday: this.birthday,
                       timezone: this.timezone,
                       first_name: this.firstName,
                       last_name: this.lastName,
                       password: this.password
                     }*/
                    this.user.country_id = this.country_id
                    await this.postRegistrationFormData(this.user)
                    if (this.getUserData.is_verified) {
                        this.$router.push('/profile')
                    }
                    if (this.getErrorMessage != '') {
                        this.errorMessage = this.getErrorMessage
                    }

                } catch (err) {
                    //console.log('onFormSubmit err', err)
                    this.formErrorMessagesFromApi = err.response.data.error
                }
                this.isSubmitButtonLoading = false
            }
        },
        mounted: async function () {
            await this.fetchCountryList()
            this.country_id = 1
            const timezone = jstz.determine()
            this.user.timezone = timezone.name()
            /*console.log(jstz.olson.timezones);
            console.log(timezone.name());*/
            /*this.$store.dispatch(AUTH_REQUEST, {rememberMe: true}).then(() => {
              this.$store.dispatch(USER_REQUEST).then(() => {
                return this.$router.push('/')
              })
            })*/
        },
        watch: {

            menuDate (val) {
                val && setTimeout(() => (this.$refs.pickerDate.activePicker = 'YEAR'))
            }
        },
    }
</script>

<style>

    .marginForm .v-input {
        margin-bottom: 7px;
    }

    .v-input {
        position: relative;
    }

    .v-text-field__slot {
        padding-right: 150px;
    }

    .v-text-field__details {
        position: absolute;
        right: 0px;
        top: 20px;
    }

    .withIcon .v-text-field__details {
        right: 34px;
    }


    /*.v-picker__body {
        width: 500px !important;
        max-width: 100% !important;
    }

    .v-card.v-picker--date{
        width: 100%;
    }*/

    .menuable__content__active.v-autocomplete__content {
        background: #33333d;
    }

</style>
